export const getLocalStorage = (key) => {
    let data = window.localStorage.getItem(key);
    let dataAsObj = null;
    try {
        dataAsObj = JSON.parse(data);
    } catch(err) {
        console.error(err);
    } finally {
        return dataAsObj;
    }
};

export const setLocalStorage = (key, data) => {
    let result = false;
    try {
        window.localStorage.setItem(key, JSON.stringify(data));
        result = true;
    } catch(err) {
        console.error(err);
    } finally {
        return result;
    }
};
